<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
<div class="pop_box" style="height: 120px;background: #fff; margin: auto;border-radius: 1%">
    <table class="pop_box_c" style="width: 336px;height: 50px;background: #fff; margin: auto;">
      <tr>
        <td style="font-size: 0.75rem;color: #595959;padding-top: 28px;padding-left: 15px;">
          <img src="../../../assets/images/pop_box.png" alt="" style="width: 7%">&nbsp;&nbsp;您的查询次数达到上限，登录后可获得更多查询次数
        </td>
      </tr>
    </table>
    <ul style="margin-top: 20px;">
      <li class="dl" style="width: 55px;height: 33.5px;background: #5092D0;float: right;border-radius: 3px;margin-right: 10px;padding-left: 15px;padding-top: 7px"><a style="font-size: 0.9rem;color:#fff;" [routerLink]="['./comLR/login']" (click)="cancel()">登录</a></li>
      <li style="width: 55px;height: 35px;float: left;border-radius:3px;margin-left: 200px;padding-left: 14px;padding-top: 7px;border: 1px solid #D9D9D9;"><a style="font-size: 0.9rem;" [routerLink]="['./comLR/register']" (click)="cancel()">注册</a></li>
    </ul>
  </div>





// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/pop-box/pop-box.component.html